<template>
  <LegacyPageContent v-if="hasProfile">
    <v-row
      no-gutters
      align="center"
      justify="center"
      class="mb-6"
    >
      <v-col cols="auto">
        <div class="headline">
          Welcome to Riverflex
        </div>
      </v-col>
    </v-row>

    <div
      v-if="!connectUser"
      class="subtitle-1 text-center"
    >
      Finding User...
    </div>

    <div v-else-if="connectUser === 'not found'">
      <p class="text-center title appRed--text">
        User is not found!
      </p>
    </div>
    <div v-else-if="connectUser && connectUser.id === user.id">
      <errorConnection msg="You can't connect to yourself" />
    </div>

    <div v-else-if="!isNewUser">
      <errorConnection msg="You can't use referral link for existing account" />
    </div>

    <div v-else-if="connectUser && connectUser.id">
      <v-container v-if="!!oppId">
        <v-row
          align="center"
          justify="center"
          class="text-center"
        >
          <p>
            Here is the
            <router-link
              class="purple--text"
              :to="linkToOpp"
            >
              opportunity
            </router-link>
            you were referred to - you can read more details and apply through this platform
          </p>
          <p>
            We’ve also connected you to <b>{{ connectUser.name }}</b> - take a look in the Connections pane below
          </p>

          <p>
            You’re also free to use the other features within this platform. Be sure to complete your
            <router-link
              class="secondary--text"
              to="/profile"
            >
              profile
            </router-link> and browse our other open opportunities...
          </p>
        </v-row>
      </v-container>
      <errorConnection
        v-else
        :title="`Hello, ${user.name}`"
        :msg="connectedWithUserMsg"
      />
      <InfoDialog
        title="Welcome to the Riverflex app!"
        :show.sync="showGDPRDialog"
        :persistent="true"
      >
        <GDPRAgreement
          @acceptAgreement="handleAcceptAgreementClick"
        />
      </InfoDialog>
    </div>

    <div v-else-if="userHasReferrer">
      <errorConnection msg="You have already had one referrer" />
    </div>
  </LegacyPageContent>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  State,
  Getter,
  Action,
  Mutation,
  namespace
} from 'vuex-class'
import { IUser } from '@/types/models/user.model'
import { trackReferralSignIn, trackOppShareReferralSignIn } from '@/segmentAnalytics/registration'
import errorConnection from '@/components/connections/ErrorConnection.vue'
import LegacyPageContent from '@/components/layouts/LegacyPageContent.vue'
import GDPRAgreement from '@/components/gdpr/GDPRAgreement.vue'
import InfoDialog from '@/components/core/InfoDialog.vue'

@Component({
  components: {
    errorConnection,
    LegacyPageContent,
    GDPRAgreement,
    InfoDialog,
  }
})
export default class Connect extends Vue {
  @Prop() hasProfile!: boolean

  @State(state => state.profile.profile) user: IUser
  @State(state => state.profile.isNewUser) isNewUser!: boolean
  @State(state => state.profile.gdprAccepted) gdprAccepted: boolean

  connectUser: IUser|null|'not-found' = null
  userHasReferrer: boolean = false
  showGDPRDialog: boolean = false;

  get connectedWithUserMsg (): string {
    if (typeof this.connectUser === 'string') return ''
    return `You are connected with ${this.connectUser ? this.connectUser.name : ''}`
  }

  get oppId (): string {
    return (this.$route.query as { opp: string }).opp
  }

  get linkToOpp (): string {
    return `/opportunities/${this.oppId}`
  }

  async created () {
    if (this.isNewUser) {
      await this.$store.dispatch('connectReferral', {
        userId: this.$route.params.id,
        oppId: this.oppId
      }).then(() => {
        if (!this.gdprAccepted) this.showGDPRDialog = true
      }).catch(error => this.userHasReferrer = true)
    }

    this.connectUser = await this.$store.dispatch('getUser', this.$route.params.id) || 'not found'
    this.trackAnalytics()
  }

  private trackAnalytics () {
    if (!this.isNewUser || this.userHasReferrer) return
    !!this.oppId ? trackOppShareReferralSignIn() : trackReferralSignIn()
  }

  handleAcceptAgreementClick () {
    this.showGDPRDialog = false
  }
}
</script>
